'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    CheckboxWithLabel: ()=>CheckboxWithLabel
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const Checkbox_variants_cjs_namespaceObject = require("../Checkbox/Checkbox.variants.cjs");
const index_cjs_namespaceObject = require("../../../utils/index.cjs");
const external_Label_index_cjs_namespaceObject = require("../../Label/index.cjs");
const Checkbox_cjs_namespaceObject = require("../Checkbox/Checkbox.cjs");
const CheckboxWithLabel = (props)=>{
    const { emphasis, size = '20', labelClassName, labelProps = {}, labelNode, isCheckboxGroup = false, layout, ...restProps } = props;
    const { labelSlot } = (0, Checkbox_variants_cjs_namespaceObject.checkboxVariants)({
        size,
        emphasis,
        isCheckboxGroup,
        layout
    });
    const labelClasses = (0, index_cjs_namespaceObject.cn)(labelSlot(), labelClassName);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_Label_index_cjs_namespaceObject.Label, {
        className: labelClasses,
        ...labelProps,
        onClick: (e)=>{
            e.stopPropagation();
        },
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Checkbox_cjs_namespaceObject.Checkbox, {
                size: size,
                emphasis: emphasis,
                isCheckboxGroup: isCheckboxGroup,
                ...restProps
            }),
            labelNode
        ]
    });
};
exports.CheckboxWithLabel = __webpack_exports__.CheckboxWithLabel;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "CheckboxWithLabel"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
